import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '@/app/layouts/app.layout.route'
import { ROUTES } from '@/shared/constants/routes'
import { FEATURE_FLAGS } from '@/shared/constants/feature-flags'
import { withFeatureGate } from '@/components/molecules'
import { PetPage } from './page.pet'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: ROUTES.PET,
  component: withFeatureGate(FEATURE_FLAGS.WEB_APP_PET, PetPage),
})
